import React from 'react';
import { Route, Routes } from 'react-router-dom';

import App from './App.tsx';
import Layout from './Layout.tsx';
import NotFoundError from './components/not-found-error/index.tsx';

const AppRoutes = () => {
    //INFO: Set the API environment based on the current hostname
    const currentHostname = window.location.hostname;
    /* istanbul ignore next -- @preserve */
    if (currentHostname === 'localhost' || currentHostname === 'development.request-survey.com') {
        window.USER_SET_API_ENV = 'dev';
    }

    return (
        <Routes>
            <Route element={<Layout />}>
                <Route path="/survey" element={<App />} />
                {/* //TODO: Translations https://uberall.atlassian.net/browse/REP-5106 */}
                <Route
                    path="/survey/error"
                    element={
                        <NotFoundError
                            title="Error - 404"
                            message="The survey is not accessible or does not exist."
                        />
                    }
                />
                {/* //TODO: Translations https://uberall.atlassian.net/browse/REP-5106 */}
                <Route
                    path="*"
                    element={
                        <>
                            <NotFoundError
                                title="Error - 404"
                                message="Doesn't look like there is anything out here."
                            />
                        </>
                    }
                />
            </Route>
        </Routes>
    );
};

export { AppRoutes };
